import React from "react";
import { Box, Typography } from "@mui/material";
import Page from "../components/Page";

const History: React.FC = () => {
  return (
    <Page title="History">
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Transaction History
        </Typography>
        <Typography variant="body1">
          Your transaction history will appear here.
        </Typography>
      </Box>
    </Page>
  );
};

export default History;
